export default "__VITE_ASSET__DVaOzBZN__"